import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { turnIntoList, unwrapList } from 'common/Prose/utils'
import { computed } from 'mobx'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext, SelectionType } from 'stores/EditorState'

export function useCheckListToggle(view: EditorView): ButtonHook {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!
  const { schema } = view.state

  const selectionInChecklist = computed(() => almanacState.containingNodeTypes.has(schema.nodes.check_list)).get()
  const selectionHasChecklist = computed(() => almanacState.activeNodes.has(schema.nodes.check_list)).get()

  const handleChecklistClick = selectionInChecklist
    ? unwrapList(view, view.state.schema.nodes.check_list)
    : turnIntoList(view, view.state.schema.nodes.check_list)

  const isDisabled = almanacState.selectionType === SelectionType.Cell

  return { active: selectionHasChecklist, handleClick: handleChecklistClick, disabled: isDisabled }
}
